import React from 'react';
interface CaretIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

const CaretIcon: React.FC<CaretIconProps> = ({
  height = 9,
  color = 'black',
  className,
  style,
}) => (
  <i
    className={['fa-solid fa-caret-down', className].filter(Boolean).join(' ')}
    style={{ fontSize: height, color, lineHeight: 1, ...style }}
    aria-hidden="true"
  />
);

export default CaretIcon;
